import { useState } from "react";
import { Button } from "../../../components/button/button";
import { AdminHeader } from "../../../components/adminHeader/adminHeader";
import { Input } from "../../../components/input/input";
import { NumberInput } from "../../../components/numberInput/numberInput";
import { workerRepeatTabs } from "./repeatTabs";
import { Retractable } from "../../../components/retractable/retractable";
import { Checkbox } from "../../../components/checkbox/checkbox.jsx";
import { useAnimatedNavigate } from "../../../hooks/useAnimatedNavigate";
import { useSelector } from "react-redux";
import AdminAPI from "../../../api/AdminAPI";
import classNames from "classnames";

import styles from "./adminTaskAddPage.module.css";
import { useParams } from "react-router";
import { Spring } from "../../../components/spring/spring.jsx";

import { Text } from "../../../components/text/text";

const InputBlock = ({ type, title, value, setValue, className, min, max, error }) => {
    return (
        <div className={classNames(styles.inputBlock, className)}>
            <Text as="div" variant="h3" className={styles.inputBlockTitle} size={14}>
                {title}
            </Text>
            {type === "number" && <NumberInput error={error} val={value} setVal={setValue} min={min} max={max} />}
            {type !== "number" && <Input error={error} type={type} value={value} setValue={setValue} />}
        </div>
    )
}

export const AdminTaskAddPage = () => {
    const [description, setDescription] = useState("");
    const [descriptionError, setDescriptionError] = useState(false);

    const [steps, setSteps] = useState(1);
    const [stepsError, setStepsError] = useState(false);

    const [isRepeating, setIsRepeating] = useState(false);
    const [repeat, setRepeat] = useState(workerRepeatTabs[0]);

    const [repeatDays, setRepeatDays] = useState(1);
    const [repeatDaysError, setRepeatDaysError] = useState(false);

    const [beginDate, setBeginDate] = useState(new Date());
    const [beginDateError, setBeginDateError] = useState(false);

    const [endDate, setEndDate] = useState(new Date());
    const [endDateError, setEndDateError] = useState(false);

    const resetErrors = () => {
        setDescriptionError(false);
        setStepsError(false);
        setRepeatDaysError(false);
        setBeginDateError(false);
        setEndDateError(false);
    }

    const validateData = () => {
        let errors = false;

        if (description.length === 0) {
            setDescriptionError(true);
            errors = true;
        }

        if (steps === 0) {
            setStepsError(true);
            errors = true;
        }

        if (repeatDays === 0) {
            setRepeatDaysError(true);
            errors = true;
        }

        const now = new Date();
        now.setHours(0, 0, 0, 0);
        if (beginDate.getTime() < now.getTime()) {
            setBeginDateError(true);
            errors = true;
        }

        if (endDate.getTime() < beginDate.getTime()) {
            setEndDateError(true);
            errors = true;
        }

        return errors;
    }

    const checklistId = useSelector(state => state.user.adminData.checklistId);

    const { cafeId } = useParams();
    const navigate = useAnimatedNavigate();
    const [loading, setLoading] = useState(false);
    const onSave = () => {
        resetErrors();
        if (checklistId === null) return;
        if (validateData()) return;

        setLoading(true);
        AdminAPI
            .createAdminTask(
                checklistId,
                description,
                isRepeating ? "reccurent" : "daily",
                steps,
                !isRepeating ? beginDate : null,
                !isRepeating ? endDate : null,
                isRepeating ? ((repeat.ownVariant) ? repeatDays : repeat.value) : null,
            )
            .then(() => {
                setTimeout(() => {
                    navigate(`/admin/${cafeId}/tasks?initialDaily=${!isRepeating}`);
                }, 100);
            })
            .catch(console.error)
            .finally(() => setLoading(false));
    }

    return (
        <>
            <AdminHeader title="Поставить задачу себе" />

            <InputBlock
                type="text"
                title="Кратко опишите задачу"
                value={description}
                setValue={setDescription}
                error={descriptionError}
            />

            <InputBlock
                type="number"
                title="Установите количество шагов в задаче, например если продать нужно 5 десертов, поставьте в поле цифру 5"
                value={steps}
                setValue={setSteps}
                error={stepsError}
            />

            <div>
                <div className={styles.checkboxContainer}>
                    <Checkbox
                        checked={isRepeating}
                        onChange={setIsRepeating}
                    />
                    <Text as="div" variant="body" className={styles.checkboxText} >
                        Повторяющаяся задача
                    </Text>
                </div>

                <Retractable active={!isRepeating}>
                    <div className={styles.dates}>
                        <InputBlock
                            type="date"
                            className={styles.startDateInput}
                            title="Дата начала"
                            value={beginDate.toISOString().split("T")[0]}
                            setValue={(val) => {
                                try {
                                    const newDate = new Date(val.split("T")[0]);
                                    newDate.toISOString();
                                    setBeginDate(newDate);
                                } catch {
                                    setBeginDate(prev => prev);
                                }
                            }}
                            error={beginDateError}
                        />

                        <InputBlock
                            type="date"
                            className={styles.startDateInput}
                            title="Дата конца"
                            value={endDate.toISOString().split("T")[0]}
                            setValue={(val) => {
                                try {
                                    const newDate = new Date(val.split("T")[0]);
                                    newDate.toISOString();
                                    setEndDate(newDate);
                                } catch {
                                    setEndDate(prev => prev);
                                }
                            }}
                            error={endDateError}
                        />
                    </div>
                </Retractable>

                <Retractable active={isRepeating}>
                    <div className={styles.repeatTabs}>
                        {
                            workerRepeatTabs.map(data => (
                                <div
                                    key={data.id}
                                    className={classNames(styles.repeatTab, { [styles.active]: data.id === repeat.id })}
                                    onClick={() => setRepeat(data)}
                                >
                                    {data.text}
                                </div>
                            ))
                        }
                    </div>

                    <Retractable active={repeat.ownVariant}>
                        <InputBlock
                            min={1}
                            className={styles.repeatDaysInput}
                            type="number"
                            title="Кол-во дней повтора"
                            value={repeatDays}
                            setValue={setRepeatDays}
                            error={repeatDaysError}
                        />
                    </Retractable>
                </Retractable>
            </div>

            <Spring />

            <Button text="Сохранить" type="primary" onClick={onSave} disabled={loading} />
        </>
    )
}
